<div class="container app-background">
    <div>
        <div class="rectangle-card">
            <div *ngIf="!selectUserBranch" class="rectangle-card-content">
                <div style="font-size: 18px; font-weight: 500">Welcome,</div><br>
                <div style="font-size: 16px;">Login to your account!</div>
                <form [formGroup]="loginForm">
                    <mat-form-field style="width: 100%; padding-bottom: 15px;">
                        <input matInput type="text" placeholder="Username" formControlName="username">
                        <mat-error *ngIf="username!.invalid">{{getusernameErrorMsg()}}</mat-error>
                    </mat-form-field>
                    <mat-form-field style="width:100%; padding-bottom: 15px;">
                        <input matInput [type]="passwordHide ? 'password' : 'text'" placeholder="Password"
                            formControlName="password" (keyup.enter)="login()">
                        <mat-icon matSuffix (click)="passwordHide = !passwordHide">{{passwordHide ? 'visibility_off' :
                            'visibility'}}</mat-icon>
                        <mat-error *ngIf="password!.invalid">{{getPasswordErrorMsg()}}</mat-error>
                    </mat-form-field>
                </form>
                <button matButton class="btn-success" (click)="login()">LOGIN</button>
                <!-- Password Management Component -->
                <app-password-management></app-password-management>
            </div>
            <div *ngIf="selectUserBranch" class="rectangle-card-content">
                <mat-form-field class="form-field-background">
                    <mat-label>Select Branch</mat-label>
                    <mat-select [(value)]="selected" [formControl]="branchSelect" #branchSelectRef="matSelect">
                        <!-- Search input within dropdown -->
                        <mat-option>
                            <input matInput placeholder="Search branch" [formControl]="searchBranchControl"
                                (click)="$event.stopPropagation()" (input)="branchSelectRef.open()">
                        </mat-option>

                        <!-- Show filtered branches or 'No results found' if no matches and user is searching -->
                        <ng-container *ngIf="filteredBranches.length > 0; else noResults">
                            <mat-option *ngFor="let option of filteredBranches" [value]="option.branch_id">
                                {{ option.branch_name }}
                            </mat-option>
                        </ng-container>

                        <ng-template #noResults>
                            <mat-option *ngIf="isSearching" disabled>No results found</mat-option>
                        </ng-template>
                    </mat-select>
                    <mat-error *ngIf="branchSelect.invalid">Please select the Branch</mat-error>
                </mat-form-field>
                <button matButton class="btn-success" (click)="proceedWithBranch()">PROCEED</button>
            </div>
        </div>
    </div>
    <app-spinner *ngIf="showSpinner"></app-spinner>
</div>